import { useState } from "react";
import { FrameworkTemplateControlViewModel } from "../FrameworkTemplateOverview.types.ts";
import { deleteHttp } from "../../../common/api/apiShared.ts";
import { FrameworkTemplateControlProps } from "./FrameworkTemplateControl.tsx";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useFrameworkTemplateControl(props: FrameworkTemplateControlProps) {
    const snackbar = useDotLegalSnackbar();
    const [showAddEditDialog, setShowAddEditDialog] = useState(false);
    const [selectedControl, setSelectedControl] = useState<FrameworkTemplateControlViewModel | undefined>(undefined);
    const [controlToDelete, setControlToDelete] = useState<FrameworkTemplateControlViewModel | undefined>(undefined);

    const deleteControlMutation = useDotLegalMutation(deleteControlApi);
    const onDeleteControl = async () => {
        await deleteControlMutation.mutateAsync(undefined, {
            onSuccess: (response: any) => {
                snackbar.show("Control deleted", "success");
                setControlToDelete(undefined);
                props.refetch();
            },
        });
    };

    return { showAddEditDialog, setShowAddEditDialog, selectedControl, setSelectedControl, controlToDelete, setControlToDelete, onDeleteControl };

    function deleteControlApi() {
        return deleteHttp(`/frameworks/templates/${props.frameworkTemplateId}/control/${controlToDelete!.id}`);
    }
}
